import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { ReactNode, useEffect, useState } from "react";
import { css } from "styled-components";

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
    showStorePickupOverlay?: boolean;
    storePickupOverlay?: ReactNode;
    showAddressBookOverlay?: boolean;
    addressBookOverlay?: ReactNode;
}

export interface PageLayoutStyles {
    headerCommon?: InjectableCss;
    headerFixed?: InjectableCss;
}

export const pageLayoutStyles: PageLayoutStyles = {
    headerCommon: {
        css: css`
            min-height: 550px;
            padding: 0;
        `,
    },

    headerFixed: {
        css: css`
            min-height: 550px;
            padding: 87px 0 0 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 0;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
};
const styles = pageLayoutStyles;
// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
    showStorePickupOverlay,
    storePickupOverlay,
    showAddressBookOverlay,
    addressBookOverlay,
}: PageLayoutProps) => {
    const [pageYOffsetValue, setPageYOffsetValue] = useState(0);
    useEffect(() => {
        window.addEventListener("scroll", event => {
            setPageYOffsetValue(window.pageYOffset);
        });
    }, []);

    return (
        <>
            {showHeader && header}
            {showCompactHeader && compactHeader}
            {showBreadcrumbs && (
                <Page as="div">
                    <PageBreadcrumbs />
                </Page>
            )}
            {pageContent && (
                <Page
                    as="section"
                    fullWidth={[true, true, true, true, true]}
                    {...(pageYOffsetValue > 136 ? { ...styles.headerFixed } : { ...styles.headerCommon })}
                >
                    {pageContent}
                </Page>
            )}
            {showFooter && footer}
            {showSignInOverlay && signInOverlay}
            {showStorePickupOverlay && storePickupOverlay}
            {showAddressBookOverlay && addressBookOverlay}
        </>
    );
};

export default PageLayout;
